/**
 * Inline SVG icons dedicated to tennis categories.
 * Scales via `size` prop. Inherits `currentColor` for theming.
 */
import React from "react";

export function RacketIcon({ size = 32, strokeWidth = 1.6, className = "" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* Racket head (ellipse) */}
      <ellipse cx="9" cy="9" rx="7" ry="7.5" />
      {/* Strings (cross pattern) */}
      <line x1="2" y1="9" x2="16" y2="9" />
      <line x1="9" y1="1.5" x2="9" y2="16.5" />
      <line x1="4" y1="4.5" x2="14" y2="13.5" opacity="0.4" />
      <line x1="14" y1="4.5" x2="4" y2="13.5" opacity="0.4" />
      {/* Throat */}
      <path d="M13.5 14 L16.5 17" />
      {/* Grip / handle */}
      <path d="M16.5 17 L21 21.5" strokeWidth={strokeWidth + 1} />
      {/* Grip end */}
      <line x1="19.5" y1="19" x2="22" y2="21.5" strokeWidth={strokeWidth + 1} />
    </svg>
  );
}

export function BallIcon({ size = 32, strokeWidth = 1.6, className = "" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* Ball (circle) */}
      <circle cx="12" cy="12" r="9" />
      {/* Classic tennis ball curved seams */}
      <path d="M3.5 9.5 C 7 11, 17 11, 20.5 9.5" />
      <path d="M3.5 14.5 C 7 13, 17 13, 20.5 14.5" />
    </svg>
  );
}
